import React from 'react';

function TechMahindra() {
  return (
    
    <section className="sec-box project section-padding radius-15">
        <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center">
              <div className="next ml-auto">
                <h6 className="sub-title back-to-work">
                  <a href="/works">
                  <i className="fas fa-long-arrow-alt-left"></i> Back to works
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-11">
          <div className="img mb-80">
            <img
              src="/assets/imgs/works/p23.jpg"
              alt=""
              className="radius-5"
            />
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="cont md-mb50">
              <h3 className="mb-15 fw-500">Project Description:</h3>
                <p>
                Worked on multiple enterprise applications and customer portals for various global clients under Tech Mahindra (formerly Satyam Computers), specializing in UI/UX design and front-end development. Designed and developed highly responsive, intuitive, and visually engaging user interfaces for business-critical applications across industries such as aviation, banking, automotive, and telecom.
                </p>
                <p className="mt-15">
                Leveraged HTML, CSS, JavaScript, jQuery, Bootstrap, and modern front-end frameworks to create sleek, interactive, and high-performance web applications. Focused on user-centric design, accessibility, and seamless navigation, ensuring an optimal digital experience for end users.
                </p>
                <div className="mt-30">
                <h6 className="mb-15 line-height-28">
                  Roles & Responsibilities:
                  </h6>
                  <p>As a <strong>UI/UX & Developer</strong>, I was responsible for:</p>
                  <ul className="rest list-arrow mt-50">
                    <li>
                      <h6 className="inline fz-15">
                      UI/UX Strategy & Design: Led the end-to-end UI/UX design process, crafting wireframes, prototypes, and high-fidelity designs to ensure intuitive user journeys.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Front-End Development: Developed responsive, cross-browser-compatible interfaces using HTML5, CSS3, JavaScript, and front-end frameworks to deliver high-performance applications.
                      </h6>
                    </li>
                   
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Customer Portals & Web Apps: Built interactive customer portals, e-commerce platforms, and service management applications, ensuring seamless user engagement.
                      </h6>
                    </li>
                   
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Dashboard & Data Visualization: Designed and implemented data-driven dashboards, providing real-time insights with enhanced UI components.
                      </h6>
                    </li>
                   
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Mobile-First & Responsive Design: Ensured all applications were mobile-friendly, with a focus on accessibility and usability across different devices.
                      </h6>
                    </li>
                   
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Performance Optimization: Optimized UI components for fast load times, improved accessibility, and smooth user interactions.
                      </h6>
                    </li>
                   
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Branding & Design Consistency: Maintained client-specific branding guidelines, ensuring consistency in design elements and user experience.
                      </h6>
                    </li>
                   
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Collaboration & Agile Development: Worked closely with cross-functional teams, including business analysts, back-end developers, and stakeholders, in an Agile environment to align UI/UX goals with business requirements.
                      </h6>
                    </li>
                   
                  </ul>
                  <p className="mt-25">
                  This diverse experience across multiple projects helped in delivering high-quality UI/UX solutions that enhanced user engagement, improved operational efficiency, and ensured a seamless digital experience across various industry domains.
                 </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="info sub-bg" id="sticky_item">
                <ul>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="far fa-calendar-alt mr-10"></i> Date :
                    </span>
                    <p>October 2011</p>
                  </li>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="fas fa-list-ul mr-10"></i> Categories :
                    </span>
                    <p>UI/UX Designer</p>
                  </li>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="far fa-user mr-10"></i> Client :
                    </span>
                    <p>Tech Mahindra (formerly Satyam Computers)</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="imgs mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row md-marg">
              <div className="col-md-6">
                <div className="img sm-mb30">
                  <img src="/assets/imgs/works/p25.jpg" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                  <img src="/assets/imgs/works/p5.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="imgs mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row md-marg">
              <div className="col-md-6">
                <div className="img sm-mb30">
                  <img src="/assets/imgs/works/p24.jpg" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                  <img src="/assets/imgs/works/p6.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="imgs mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row md-marg">
              <div className="col-md-6">
                <div className="img sm-mb30">
                  <img src="/assets/imgs/works/p3.jpg" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                  <img src="/assets/imgs/works/p15.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="imgs mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row md-marg">
              <div className="col-md-6">
                <div className="img sm-mb30">
                  <img src="/assets/imgs/works/p28.jpg" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                  <img src="/assets/imgs/works/p35.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center mt-80 pt-80 bord-thin-top">
              <div className="prev">
                <h6 className="sub-title">
                  <a href="/bombardier">
                    <i className="fas fa-long-arrow-alt-left"></i> Prev Project
                  </a>
                </h6>
              </div>
              <div className="next ml-auto">
                <h6 className="sub-title">
                  <a href="/freelance">
                    next Project <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TechMahindra;
